import { notFound } from 'next/navigation';

import { getChannel, getDocument, getPlaceId, replaceDynamicData } from '@lib/server';
import type { BannerComponentFields, Place } from '@types';

export async function getVenuePageData(domain: string, venue: string) {
  const channel = await getChannel(domain);

  if (!channel?.channelId) notFound();

  const { placeId } = await getPlaceId(channel, venue);

  if (!placeId) notFound();

  const place = await getDocument<Place>('place', placeId, {
    tags: [channel.channelId],
    depth: 1,
    visibilityId: placeId,
    select: [
      'fields.default',
      'fields.name',
      'fields.custom.venueHeroBanners',
      'fields.custom.homepageTemplate',
      'fields.custom.siteId',
      'id',
    ],
  });

  if (!place?.fields) notFound();

  const dynamicPlace = replaceDynamicData(place.fields);

  if (!dynamicPlace?.custom?.homepageTemplate) notFound();

  const {
    custom: { homepageTemplate, ...custom },
  } = dynamicPlace;

  const page = homepageTemplate?.find(({ template }) => template === channel.theme)?.page;

  if (!page) notFound();

  const venueHeroBanners = custom?.venueHeroBanners?.filter(({ template }) => template === channel.theme);

  const heroBanner = {
    ...venueHeroBanners?.[0]?.heroBanner,
    slides: venueHeroBanners
      ?.flatMap(({ heroBanner }) => heroBanner?.slides?.map((slide) => slide))
      ?.filter(Boolean) as BannerComponentFields[],
  };

  return {
    transitionName: channel.themeConfig?.animations,
    heroBanner,
    page,
  };
}
